import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, ConnectCreditCardDialogueHandler } from '../types';
import ConnectCreditCardContext from '../ConnectCreditCardContext';
import { useLayout } from '@/providers/Layout.provider';

const { ConfirmationDialogue } = vp;

type ConnectCreditCardDialogueProps = {
  handleDialogue: DialogueHandler<ConnectCreditCardDialogueHandler>;
};

type FC = FunctionComponent<ConnectCreditCardDialogueProps>;

const ConnectCreditCardDialogue: FC = ({ handleDialogue }: ConnectCreditCardDialogueProps) => {
  const {
    showConnectCreditCardSuccessAlert,
    showConnectCreditCardErrorAlert,
    connectCreditCardError,
    showConnectSameCreditCardErrorAlert,
    showConnectCreditCardFailAlert,
    connectCreditCardErrorTitle,
  } = useContext(ConnectCreditCardContext);
  const { t } = useTranslation('translations', { keyPrefix: 'CreditCardDialouge' });
  const { color } = useLayout();
  return useMemo(
    () => (
      <div>
        {/* Create Credit Card Error */}
        <ConfirmationDialogue
          isVisible={showConnectCreditCardErrorAlert}
          title={`${connectCreditCardErrorTitle || t('notconnectedError')}`}
          status="error"
          subTitle={`${connectCreditCardError}`}
          buttonTextColor={vp.getContrastColor(color)}
          confirm={{
            label: `${t('backButton')}`,
            action: () => handleDialogue({ type: 'create', state: 'fail' }),
          }}
        />
        {/* Create Credit Card AlreadyConnected */}
        <ConfirmationDialogue
          isVisible={showConnectSameCreditCardErrorAlert}
          title={`${t('alreadyconnectedError')}`}
          status="error"
          buttonTextColor={vp.getContrastColor(color)}
          subTitle={`${connectCreditCardError}`}
          confirm={{
            label: `${t('backButton')}`,
            action: () => handleDialogue({ type: 'create', state: 'fail' }),
          }}
        />
        {/* Create Credit Card Success */}
        <ConfirmationDialogue
          isVisible={showConnectCreditCardSuccessAlert}
          title={`${t('successfullMsg')}`}
          status="success"
          buttonTextColor={vp.getContrastColor(color)}
          subTitle=""
          confirm={{
            label: `${t('doneButton')}`,
            action: () => handleDialogue({ type: 'create', state: 'success' }),
          }}
        />
        {/* Create Credit Card Fail */}
        <ConfirmationDialogue
          isVisible={showConnectCreditCardFailAlert}
          title={<>{`${t('incorrectInfomrationError')}`}</>}
          variant="creditCard"
          buttonTextColor={vp.getContrastColor(color)}
          status="fail"
          buttonColor="primary"
          subTitle=""
          confirm={{
            label: `${t('backButton')}`,
            action: () => handleDialogue({ type: 'connect', state: 'success' }),
          }}
        />
      </div>
    ),
    [
      showConnectCreditCardSuccessAlert,
      showConnectCreditCardErrorAlert,
      showConnectSameCreditCardErrorAlert,
      showConnectCreditCardFailAlert,
      connectCreditCardErrorTitle,
    ],
  );
};

export default ConnectCreditCardDialogue;
